// extracted by mini-css-extract-plugin
module.exports = {"liveBadge":"LiveBadge_liveBadge__R3gve","liveBadgeCircle":"LiveBadge_liveBadgeCircle__62eJs"};